import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { PAYMENT } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const initialState = {
	clientCards: null,
	subscriptionDiscountedAmount: null,
	subscriptionPromoCodeCheck: null,
	subscriptionRetryPaymentAmount: null,
	manageSubscriptionData: null,
	paymentResult: null
};

export const getSubscriptionDiscountedAmount = createAsyncThunk(
	'subscriptionAccount/getSubscriptionDiscountedAmount',
	async (payload, { rejectWithValue }) => {
		const axiosPrivate = useAxiosPrivate();
		try {
			const response = await axiosPrivate.post(PAYMENT.GET_DISCOUNTED_AMOUNT_FOR_UPGRADE, {
				paymentType: payload.paymentType,
				newPackageID: payload.newPackageID,
				oldPackageID: payload.oldPackageID,
				promoCode: payload.promoCode
			});
			if (response.status === 200) {
				return response.data;
			} else {
				throw new Error(response);
			}
		} catch (error) {
			AppLogger.error(error);
			throw rejectWithValue(error);
		}
	}
);

export const getManageSubscriptionData = createAsyncThunk(
	'subscriptionAccount/getManageSubscriptionData',
	async (_, { getState, rejectWithValue }) => {
		const { subscriptionAccount } = getState();
		if (subscriptionAccount.manageSubscriptionData !== null) {
			return subscriptionAccount.manageSubscriptionData;
		}
		const axiosPrivate = useAxiosPrivate();
		try {
			const response = await axiosPrivate.post(PAYMENT.GET_MANAGE_SUBSCRIPTION, {});

			if (response.status === 200) {
				return response.data;
			} else {
				AppLogger.error(response);
			}
		} catch (error) {
			AppLogger.error(error);
			throw rejectWithValue(error);
		}
	}
);

const subscriptionAccount = createSlice({
	name: 'subscriptionAccount',
	initialState,
	reducers: {
		setPaymentResult: (state, { payload: paymentResult }) => ({ ...state, paymentResult }),

		setManageSubscriptionReload: (state, { payload: manageSubscriptionReload }) => ({
			...state,
			manageSubscriptionReload
		}),

		setSubscriptionPromoCodeCheck: (state, { payload: subscriptionPromoCodeCheck }) => ({
			...state,
			subscriptionPromoCodeCheck
		}),
		setSubscriptionRetryPaymentAmount: (state, { payload: subscriptionRetryPaymentAmount }) => ({
			...state,
			subscriptionRetryPaymentAmount
		}),
		clearStates: () => initialState
	},
	extraReducers: (builder) => {
		builder.addCase(getSubscriptionDiscountedAmount.fulfilled, (state, { payload }) => ({
			...state,
			subscriptionDiscountedAmount: payload
		}));
		builder.addCase(getManageSubscriptionData.fulfilled, (state, { payload }) => ({
			...state,
			manageSubscriptionData: payload
		}));
	}
});

export const {
	setPaymentResult,
	setManageSubscriptionReload,
	setSubscriptionPromoCodeCheck,
	setSubscriptionRetryPaymentAmount,
	clearStates
} = subscriptionAccount.actions;

export default subscriptionAccount.reducer;
